import { useTerminologyReplacer } from "@/hooks/useTerminologyReplacer";
import { TerminologyOptions, IconNames } from "@/types/v2";
import { Icon } from "@/components/Common/Icon";

export const NotesHeader = () => {
  const { terminolize } = useTerminologyReplacer();
  return (
    <div className="flex items-center gap-2">
      <Icon name={IconNames.message} size={20} />
      <h2 className="text-xl font-semibold">
        {terminolize("RO", TerminologyOptions.repairOrder, "acronym")} Notes
      </h2>
    </div>
  );
};
